var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"text-capitalize mt-0 pt-2 mb-2",attrs:{"dense":"","label":_vm.$t(_vm.label),"input-value":_vm.value,"rules":_vm.rules},on:{"change":val => _vm.$emit('input', val)}},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }